import React, { useEffect, useState } from "react";
import {
  examtitlelist,
  stuacademicyearlist,
  stuclasslist,
  studivisionlist,
  stusubjectlist,
} from "../../../services/master";
import { AgGridReact } from "ag-grid-react";
import {
  academylist,
  listexamdetail,
} from "../../../services/admin";
import Select from "react-select";
import { toast } from "react-toastify";

export default function ExaminationReport() {
  const [aclist, setAcList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const [ayear, setAYear] = useState("");
  const [alist, setAList] = useState([]);

  const [etitle, setETitle] = useState("");
  const [tlist, setTList] = useState([]);

  const [stucls, setStuCls] = useState("");
  const [clist, setCList] = useState([]);

  const [stusec, setStuSec] = useState("");
  const [seclist, setSecList] = useState([]);

  const [stusub, setStuSub] = useState("");
  const [slist, setSList] = useState([]);

  const [rlist, setRList] = useState("");

  useEffect(() => {


    stuclasslist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].class_name,
            });
          }
          setCList(arr);
        }
      }
    });

    studivisionlist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].name,
            });
          }
          setSecList(arr);
        }
      }
    });

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAcList(arr);
        }
      }
    });

    examtitlelist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].exam_title,
            });
          }
          setTList(arr);
        }
      }
    });

    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listall(arr[0]);
                setAYear(localStorage.getItem("AYear"));
              }
            }
           
          }
        }
      });
    }else{
      listall("");
    }
  }, []);

  const [filterProduct, setFilterProduct] = useState([]);

  const columnDefs = [
    {
      headerName: "Student",
      field: "student_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Username",
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Academic Year",
      field: "aca_year",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Class",
      field: "class_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Section",
      field: "section_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Exam",
      field: "exam_title",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Subject",
      field: "subject_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Present/Absent",
      field: "present_absent",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: (params) => {
        const value = params.value;

        if (value === 'Present') {
          return <span className="text-success" >{value}</span>;

        } else if (value === 'Absent') {
          return <span className="text-danger">{value}</span>;
        }

      }
    },
    {
      headerName: "Theory",
      field: "theory_mark",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Practical",
      field: "practical_mark",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Total",
      field: "total",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Pass/Fail",
      field: "pass_mark",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: (params) => {
        const value = params.value;

        if (value === 'Pass') {
          return <span className="text-success" >{value}</span>;

        } else if (value === 'Fail') {
          return <span className="text-danger">{value}</span>;
        }

      }
    },
  ];


  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e);
      filterstu(e, ayear, stucls, stusec, etitle, stusub, rlist);
    } else {
      setAcaID("");
      listall("");
      filterstu("", ayear, stucls, stusec, etitle, stusub, rlist);

    }
  }

  function listall(aid) {
    setAList([]);
    setAYear("");
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    stuacademicyearlist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].aca_year,
            });
          }
          setAList(arr);
        }
      }
    });

      stusubjectlist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].subject_name,
            });
          }
          setSList(arr);
        }
      }
    });
  
  }

  function filterstu(aca, yr, cls, sec, etit, sub, ltype) {
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (aca === "") {
        toast.error("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }

    if (valid === "") {
      // if (ayear !== "") {
      //   if (stucls !== "") {
      //     if (stusec !== "") {
      //       if (etitle !== "") {
      //         if (stusub !== "") {
      const temp1 = new FormData();
      temp1.append("year_id", yr);
      temp1.append("class_id", cls);
      temp1.append("section_id", sec);
      temp1.append("subject_id", sub);
      temp1.append("exam_title_id", etit);
      if (
        localStorage.getItem("Role") === "1" &&
        aca !== ""
      ) {
        temp1.append("academy_id", aca.value);
      }

      listexamdetail(temp1).then((res1) => {
        if (res1.status === true && res1.data) {
          const updatedArr = res1.data.map((item) => {
            const theoryMarks = item.theory_mark ? parseInt(item.theory_mark) : 0;
            const practicalMarks = item.practical_mark ? parseInt(item.practical_mark) : 0;

            const totalMarks = theoryMarks + practicalMarks;

            const passMarks = item.pass_mark ? parseInt(item.pass_mark) : 0;

            const isPassed = (totalMarks >= passMarks ? 'Pass' : 'Fail');

            return {
              ...item,
              present_absent: item.present_absent == 1 ? `Present` : `Absent`,
              total: totalMarks,
              pass_mark: isPassed,
            };

          });
          let filteredArr = updatedArr;

          if (ltype === "Pass") {
            filteredArr = updatedArr.filter(item => item.pass_mark === 'Pass');
          } else if (ltype === "Fail") {
            filteredArr = updatedArr.filter(item => item.pass_mark === 'Fail');
          }
          setFilterProduct(filteredArr);
        }
      });
      //         } else {
      //           setSErrMsg("Please Select Subject");
      //         }
      //       } else {
      //         setSErrMsg("Please Select Exam Title");
      //       }
      //     } else {
      //       setSErrMsg("Please Select Section");
      //     }
      //   } else {
      //     setSErrMsg("Please Select Class");
      //   }
      // } else {
      //   setSErrMsg("Please Select Academic Year");
      // }
    }
  }

  function submitrep(e) {
    e.preventDefault();
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
        if (acaid === "") {
            valid = "Please Select Academy";
            toast.error(valid);
            return
        }
    }
    let aca = ''
    if (localStorage.getItem("Role") === "1" && acaid !== "") {
        aca = acaid.value
    }
    const reportUrl = localStorage.getItem("reportUrl");
        window.open(reportUrl + 'report/listexamexcel?academy_id=' + aca + '&year_id=' + ayear + '&class_id=' + stucls + '&section_id=' + stusec + '&subject_id=' + stusub + '&exam_title_id=' + etitle + '&type=' + rlist, "_blank");
}

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">
          Examination Report
        </h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Reports</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Examination Report
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h2 className="main-content-title tx-24 mg-b-5">
                    Examination Report
                  </h2>
                </div>
                <div className="card-body">
                  <div className="row">
                    {localStorage.getItem("Role") === "1" && (
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Select Academy{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Academy"
                            value={acaid}
                            options={aclist}
                            onChange={handleAcademy}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>
                    )}

                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-6">
                        <label className="form-label">
                          Academic Year
                          {/* <span className="text-danger"> *</span> */}
                        </label>
                        <select
                          className="default-select form-control wide"
                          onChange={(e) => {
                            setAYear(e.target.value);
                            filterstu(acaid, e.target.value, stucls, stusec, etitle, stusub, rlist);
                          }}
                          value={ayear}
                        >
                          <option value="" disabled>
                            Select Academic Year
                          </option>
                          {alist.map((item) => (
                            <option value={item.value} key={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-6">
                        <label className="form-label">
                          Select Class{/* <span className="text-danger"> *</span> */}
                        </label>
                        <select
                          className="default-select form-control wide"
                          onChange={(e) => { setStuCls(e.target.value); filterstu(acaid, ayear, e.target.value, stusec, etitle, stusub, rlist); }}
                          value={stucls}
                        >
                          <option value="" disabled>
                            Select Class
                          </option>
                          {clist.map((item) => (
                            <option value={item.value} key={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-6">
                        <label className="form-label">
                          Section{/* <span className="text-danger"> *</span> */}
                        </label>
                        <select
                          className="default-select form-control wide"
                          onChange={(e) => { setStuSec(e.target.value); filterstu(acaid, ayear, stucls, e.target.value, etitle, stusub, rlist); }}
                          value={stusec}
                        >
                          <option value="" disabled>
                            Select Section
                          </option>
                          {seclist.map((item) => (
                            <option value={item.value} key={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-6">
                        <label className="form-label">
                          Exam Title{/* <span className="text-danger"> *</span> */}
                        </label>
                        <select
                          className="default-select form-control wide"
                          onChange={(e) => { setETitle(e.target.value); filterstu(acaid, ayear, stucls, stusec, e.target.value, stusub, rlist); }}
                          value={etitle}
                        >
                          <option value="" disabled>
                            Select Exam Title
                          </option>
                          {tlist.map((item) => (
                            <option value={item.value} key={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-6">
                        <label className="form-label">
                          Select Exam Subjects
                          {/* <span className="text-danger"> *</span> */}
                        </label>
                        <select
                          className="default-select form-control wide"
                          onChange={(e) => { setStuSub(e.target.value); filterstu(acaid, ayear, stucls, stusec, etitle, e.target.value, rlist); }}
                          value={stusub}
                        >
                          <option value="" disabled>
                            Select Exam Subjects
                          </option>
                          {slist.map((item) => (
                            <option value={item.value} key={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-6">
                        <label className="form-label">
                          Select Report Type
                          {/* <span className="text-danger"> *</span> */}
                        </label>
                        <select
                          className="default-select form-control wide"
                          onChange={(e) => { setRList(e.target.value); filterstu(acaid, ayear, stucls, stusec, etitle, stusub, e.target.value); }}
                          value={rlist}
                        >
                          <option value="" disabled>
                            Select Report Type
                          </option>
                          <option value='Pass'>
                            Student Pass Report
                          </option>
                          <option value='Fail'>
                            Student Fail Report
                          </option>
                          <option value='Attendance'>
                            Student Attendance Report
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-8 col-sm-6">
                      <div className="res-right mt-5">
                        <button className="btn btn-success me-2" onClick={submitrep}>
                          Excel Download
                        </button>

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div className="col-lg-12 mt-2">
              <div className="card custom-card mg-b-20">
                <div className="card-body">
                  <div className="card-header">
                    <h2 className="main-content-title tx-24 mg-b-5">
                      Enter Subject Mark

                    </h2>
                  </div>
                  <div className="ag-theme-alpine ag-style">
                    <AgGridReact
                      columnDefs={columnDefs}
                      rowData={filterProduct}
                      pagination="true"
                      paginationPageSize="10"
                      sortingOrder={["asc", "desc"]}
                      suppressDragLeaveHidesColumns={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
}
